// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormFieldStyles } from "@eisinc/Overrides/Components/CustomerAddressFormFields";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";

const halfGridItemWidth: GridItemProps["width"] = [12, 12, 6, 6, 6];

customerAddressFormFieldStyles.firstNameGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.lastNameGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.companyNameGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.attentionGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.address1GridItem = {
    width: 12,
};

customerAddressFormFieldStyles.address2GridItem = {
    width: 12,
};

customerAddressFormFieldStyles.address3GridItem = {
    width: 12,
};

customerAddressFormFieldStyles.address4GridItem = {
    width: 12,
};

customerAddressFormFieldStyles.addAddressLineLinkGridItem = {
    width: 12,
};

customerAddressFormFieldStyles.cityGridItem = {
    width: 12,
};

customerAddressFormFieldStyles.stateGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.countryGridItem = {
    width: halfGridItemWidth,
    css: css`
        position: relative;
    `,
};

customerAddressFormFieldStyles.phoneGridItem = {
    width: halfGridItemWidth,
};

customerAddressFormFieldStyles.emailGridItem = {
    width: 12,
};

customerAddressFormFieldStyles.faxGridItem = {
    width: halfGridItemWidth,
};
